module.exports = __webpack_public_path__ + "static/media/press-yahoo.c9fb3e1b.jpg";